<template>
  <div class="table-container">
    <el-table :data="list" style="width: 100%" @row-click="onRowClick" :header-cell-style="{
      background: '#fafafa',
      color: '#333',
      fontWeight: 400,
      height: '54px'
    }" :row-style="{  
        height: '54px'
      }" highlight-current-row>
      <el-table-column prop="trueName" label="姓名" min-width="80" align="center">
        <template slot-scope="scope">
          {{ displayName(scope.row.trueName) }}
        </template>
      </el-table-column>
      <el-table-column prop="sex" label="性别" min-width="50" align="center"></el-table-column>
      <el-table-column label="年龄" min-width="70" align="center">
        <template slot-scope="scope">
          {{ getDisplayAge(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="手机号" min-width="100" align="center">
        <template slot-scope="scope">
          {{ displayMobile(scope.row.mobile) }}
        </template>
      </el-table-column>
      <el-table-column v-if="shouldShowMedicalRecord" prop="mzh" label="病案号" min-width="100" align="center"></el-table-column>
      <el-table-column prop="statusDesc" label="睡眠监测状态" min-width="160" align="center"></el-table-column>
      <el-table-column prop="hospitalName" label="机构" :min-width="showRecord ? 140 : 180" align="center"></el-table-column>
      <el-table-column label="操作" min-width="310" align="center">
        <template slot-scope="scope">
          <div class="cell-unit-content">
            <cell-unit color="#f45c50" :iconSRC="trashSRC" title="删除" @onClick="onDeleteClick(scope.row)"></cell-unit>
            <div class="cell-unit-content-slash"></div>
            <cell-unit color="#325FAC" :iconSRC="detailSRC" title="详情" @onClick="onDetailClick(scope.row)"></cell-unit>
            <div class="cell-unit-content-slash"></div>
            <cell-unit color="#325FAC" :iconSRC="editSRC" title="编辑" @onClick="onEditClick(scope.row)"></cell-unit>
            <div class="cell-unit-content-slash"></div>
            <report-cell-unit title="查看报告" :validIconSRC="previewValidSRC" :inValidIconSRC="previewInvalidSRC"
              :isValid="scope.row.isReport == 1" @onClick="onPreviewClick(scope.row)"></report-cell-unit>
            <template v-if="showRecord">
              <div class="cell-unit-content-slash"></div>
              <el-button style="color:#325FAC" type="text" @click="onRecordClick(scope.row)">记录</el-button>
            </template>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import dayjs from "dayjs";
import CellUnit from "@c/user-manage/cell-unit.vue";
import ReportCellUnit from "@c/report/sleep-report/cell-unit.vue";
import { Button } from "element-ui";
import {
  getDisplayName,
  getDisplayMobile,
} from "@js/anonymization-tool.js";
export default {
  name: 'UserTable',

  components: {
    CellUnit,
    ReportCellUnit,
    ElButton: Button,
  },

  props: {
    list: {
      type: Array,
      required: true,
    },
    showRecord: {
      type: Boolean,
      required: false,
    }
  },

  computed: {
    shouldShowMedicalRecord() {
      return this.$store.state.selectedHospital.hospitalid === 599;
    },

  },

  data: function () {
    return {
      trashSRC: require("@imgs/trash.png"),
      editSRC: require("@imgs/edit.png"),
      detailSRC: require("@imgs/detail.png"),
      previewValidSRC: require("@imgs/report-preview.png"),
      previewInvalidSRC: require("@imgs/report-preview-gray.png"),
      currentIndex: undefined
    }
  },

  methods: {
    displayName(value) {
      return getDisplayName(value, this.$store.state.accountInfo);
    },

    displayMobile(value) {
      return getDisplayMobile(value, this.$store.state.accountInfo);
    },

    getDisplayAge(row) {
      const { hospitalId, birthday, age } = row;
      // 深圳市南山区妇幼保健院耳鼻喉科503 ，佛山市复星禅城医院儿科二区1456 定制。
      if ((hospitalId === 503 || hospitalId === 1456) && birthday) {
        return this.formatAgeWithMonth(birthday);
      }
      return age;
    },

    formatAgeWithMonth(birthday) {
      if (!birthday) return '-';
      const birth = dayjs(birthday);
      if (!birth.isValid()) return '-';
      const now = dayjs();
      const years = now.diff(birth, 'year');
      const months = now.diff(birth.add(years, 'year'), 'month');
      if (years === 0) return `${months}月`;
      if (months === 0) return `${years}岁`;
      return `${years}岁${months}月`;
    },

    onRowClick(row) {
      this.$emit('row-click', row);
    },

    onDeleteClick(row) {
      this.$emit('delete', row);
    },

    onDetailClick(row) {
      this.$emit('detail', row);
    },

    onEditClick(row) {
      this.$emit('edit', row);
    },

    onPreviewClick(row) {
      this.$emit('preview', row);
    },

    onRecordClick(row) {
      this.$emit('record', row);
    }
  }
};
</script>

<style lang="scss" scoped>
.table-container {
  :deep(.el-table) {}

  :deep(.current-row) {
    .el-table__cell {
      background-color: #e6f7ff;
    }
  }

}

.cell-unit-content {
  display: flex;
  align-items: center;
  justify-content: center;

  &-slash {
    background-color: #e9e9e9;
    width: rem(1);
    height: rem(14);
    margin-left: rem(10);
    margin-right: rem(10);
  }
}


:deep(.el-table__empty-block) {
  display: none;
}
</style>
